module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Bestellijst"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(_vm.orderList === null) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n           Bestellijst: " + _vm._s(_vm.orderList.name) + "\n           "), _c('order-list-status-badge', {
    ref: "orderListStatus",
    staticClass: "ml-2",
    attrs: {
      "orderList": _vm.orderList
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n           Producten toevoegen\n         ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content p-0 row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productName),
      expression: "productName"
    }],
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "list": "products",
      "placeholder": "Vul een product naam in"
    },
    domProps: {
      "value": (_vm.productName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.productName = $event.target.value
      }, _vm.getProducts]
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "products"
    }
  }, _vm._l((_vm.products), function(item) {
    return _c('option', {
      key: item.id
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.addProductToOrderList
    }
  }, [_vm._v("\n           Toevoegen aan bestellijst"), _c('i', {
    staticClass: "fa fa-check"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Producten")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toPredictSalesDate),
      expression: "toPredictSalesDate"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Periode van"
    },
    domProps: {
      "value": (_vm.toPredictSalesDate)
    },
    on: {
      "change": _vm.predictSalesForAllProducts,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toPredictSalesDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    ref: "table",
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Product")]), _vm._v(" "), _c('th', [_vm._v("Uitverkocht")]), _vm._v(" "), _c('th', [_vm._v("Voorspelde aantal")]), _vm._v(" "), _c('th', [_vm._v("Te bestellen aantal")]), _vm._v(" "), _c('th', [_vm._v("Acties")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderList.lines), function(line) {
    return _c('tr', {
      key: line.id
    }, [_c('td', [_vm._v(_vm._s(line.product.name))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "date",
        "placeholder": "Periode van"
      },
      on: {
        "change": function($event) {
          _vm.predictSalesPerProduct($event, line.product)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center font-w600"
    }, [_vm._v(" " + _vm._s(_vm.predictedProductSales[line.product.sku]) + " ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.toOrderAmountProducts[line.product.sku]),
        expression: "toOrderAmountProducts[line.product.sku]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.toOrderAmountProducts[line.product.sku])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.toOrderAmountProducts, line.product.sku, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.deleteOrderListLine(line)
        }
      }
    }, [_vm._v("\n                   Verwijderen\n                 ")])])])
  }), 0)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.updateOrderListLines(_vm.orderList.id)
      }
    }
  }, [_vm._v("\n         Bestellen "), _c('i', {
    staticClass: "fa fa-check"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49e62593","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/order-lists/OrderListDetailModal.vue
// module id = 712
// module chunks = 1